export default __webpack_public_path__ + "static/7-54fcc67b54fe681be3e116a4c063ebdf.gif";